import React, {useEffect} from "react";
import {Outlet, useParams} from "react-router-dom";
import {useSetAtom} from "jotai";
import {AppLayout} from "../AppLayout";
import {BaseFilterPanel} from "../panels/BaseFilterPanel";
import {routerCompanyIdAtom, routerFarmIdAtom, routerFieldIdAtom} from "../../store/routerStore";
import {useCompanyIdPersist} from "../../hooks/companyIdPersistHooks";
import {BaseContextPanel} from "../panels/BaseContextPanel";

export const MapPage: React.FC = () => {
    useRouterParamsStoreSync();
    useCompanyIdPersist();

    return (
        <AppLayout sidePanel={<BaseFilterPanel basePath="map" />} rightPanel={<BaseContextPanel />}>
            <Outlet />
        </AppLayout>
    );
};

/**
 * Retrieves Router (URL path) params and sets them in Store
 */
const useRouterParamsStoreSync = () => {
    const {companyId, farmId, fieldId} = useParams();
    const setRouterCompanyId = useSetAtom(routerCompanyIdAtom);
    const setRouterFarmId = useSetAtom(routerFarmIdAtom);
    const setRouterFieldId = useSetAtom(routerFieldIdAtom);

    useEffect(() => {
        setRouterCompanyId(companyId);
    }, [companyId, setRouterCompanyId]);

    useEffect(() => {
        setRouterFarmId(farmId);
    }, [farmId, setRouterFarmId]);

    useEffect(() => {
        setRouterFieldId(fieldId);
    }, [fieldId, setRouterFieldId]);
};
